import {RootState} from 'redux/rootReducer';
import {createSelector} from '@reduxjs/toolkit';

export const projectStatus = createSelector(
  [(state: RootState) => state.project.isLoading],
  isLoading => isLoading,
);

export const projectList = createSelector(
  [(state: RootState) => state.project.projectsList],
  projects => projects,
);

export const allProjectList = createSelector(
  [(state: RootState) => state.project.allProjects],
  allProjects => allProjects,
);

export const projectSuccess = createSelector(
  [(state: RootState) => state.project.successProjectState],
  successProjectState => successProjectState,
);

export const projectFailure = createSelector(
  [(state: RootState) => state.project.errorProjectState],
  errorProjectState => errorProjectState,
);
export const projectTotalPages = createSelector(
  [(state: RootState) => state.project.totalProjectPages],
  totalProjectPages => totalProjectPages,
);

export const projectNextPage = createSelector(
  [(state: RootState) => state.project.nextProjectPage],
  nextProjectPage => nextProjectPage,
);

export const selectedProjectID = createSelector(
  [(state: RootState) => state.project.selectedProjectData.id],
  id => id,
);

export const selectedProjectData = createSelector(
  [(state: RootState) => state.project.selectedProjectData.data],
  data => data,
);

export const projectName = createSelector(
  [(state: RootState) => state.project.selectedProjectData.name],
  data => data,
);

export const selectedProjectTeam = createSelector(
  [(state: RootState) => state.project.selectedProjectData.team],
  team => team,
);
